import React from 'react';
import { motion } from 'framer-motion';

interface MosaicOverlayProps {
  rows?: number;
  cols?: number;
  reveal?: boolean; // when true, play the materialize in; when false, fade out
  durationMs?: number;
}

const noiseDelay = (r: number, c: number, rows: number, cols: number) => {
  const nx = r / rows;
  const ny = c / cols;
  // simple deterministic noise-like delay
  return (Math.sin(nx * 12.9898 + ny * 78.233) * 43758.5453) % 1;
};

const MosaicOverlay: React.FC<MosaicOverlayProps> = ({ rows = 18, cols = 30, reveal = true, durationMs = 1200 }) => {
  // Use reveal parameter to control animation direction
  const cells: Array<{ key: string; style: React.CSSProperties; delay: number }> = [];
  for (let r = 0; r < rows; r++) {
    for (let c = 0; c < cols; c++) {
      const delay = noiseDelay(r, c, rows, cols);
      cells.push({
        key: `${r}-${c}`,
        style: { gridRow: r + 1, gridColumn: c + 1 },
        delay
      });
    }
  }

  const total = durationMs / 1000;
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden">
      <div className="absolute inset-0 grid" style={{ gridTemplateRows: `repeat(${rows}, 1fr)`, gridTemplateColumns: `repeat(${cols}, 1fr)` }}>
        {cells.map(({ key, style, delay }) => (
          <motion.div
            key={key}
            style={{ ...style, aspectRatio: '1 / 1' }}
            initial={{ opacity: reveal ? 0 : 1 }}
            animate={{ opacity: reveal ? 1 : 0 }}
            transition={{ delay: delay * total, duration: 0.35, ease: 'easeInOut' }}
            className="bg-cyan-400/10"
          />
        ))}
      </div>
    </div>
  );
};

export default MosaicOverlay;


